
function Dashboard() {

  return (
    <>
      <h2>Welcome to Rivel Connect</h2>
    </>
  )
};


export default Dashboard;